/** SQL column types for MySQL
    @readonly
    @enum {string}
*/
export var COLUMNTYPE;
(function (COLUMNTYPE) {
    COLUMNTYPE["VARCHAR"] = "VARCHAR";
    COLUMNTYPE["CHAR"] = "CHAR";
    COLUMNTYPE["ENUM"] = "ENUM";
    COLUMNTYPE["TEXT"] = "TEXT";
    COLUMNTYPE["BLOB"] = "BLOB";
    COLUMNTYPE["INT"] = "INT";
    COLUMNTYPE["TINYINT"] = "TINYINT";
    COLUMNTYPE["SMALLINT"] = "SMALLINT";
    COLUMNTYPE["MEDIUMINT"] = "MEDIUMINT";
    COLUMNTYPE["BIGINT"] = "BIGINT";
    COLUMNTYPE["FLOAT"] = "FLOAT";
    COLUMNTYPE["DOUBLE"] = "DOUBLE";
    COLUMNTYPE["DECIMAL"] = "DECIMAL";
    COLUMNTYPE["DATE"] = "DATE";
    COLUMNTYPE["DATETIME"] = "DATETIME";
})(COLUMNTYPE || (COLUMNTYPE = {}));
;
